import { render, staticRenderFns } from "./PgaActivitiesPageIndex.vue?vue&type=template&id=2fde71b4&"
import script from "./PgaActivitiesPageIndex.vue?vue&type=script&lang=ts&"
export * from "./PgaActivitiesPageIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fde71b4')) {
      api.createRecord('2fde71b4', component.options)
    } else {
      api.reload('2fde71b4', component.options)
    }
    module.hot.accept("./PgaActivitiesPageIndex.vue?vue&type=template&id=2fde71b4&", function () {
      api.rerender('2fde71b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Activity/PgaActivitiesPageIndex.vue"
export default component.exports